let versions=["1.0.0","1.1.0"];//最后一个表示当前版本
let refresh=false;
//检查版本
function checkVersion(){
    let localVersion=window.localStorage["version"];
    if(typeof localVersion =="undefined"||localVersion==""||localVersion==null){
        window.localStorage["version"]="1.0.0";
    }
    console.log(`当前版本${localVersion||versions[versions.length-1]}`);
    if(localVersion&&localVersion!==versions[versions.length-1]){
        window.localStorage["version"]=versions[versions.length-1];
        versionDo(localVersion);
        return;
    }
    window.localStorage["version"]=versions[versions.length-1];
    if(refresh){
        refresh=false;
        window.location.reload();
    }
}

//版本更新执行脚本
let scriptMap={
    "1.0.0":function(oldVersion){
        console.log("1.0.0的脚本执行完成");
    },
    "1.1.0":function(oldVersion){
        refresh=true;
        console.log("1.1.0的脚本执行完成");
    },
    "test":function(oldVersion){
        console.log("test脚本执行完成");
    }
};


function versionDo(oldVersion){
    let idx=versions.indexOf(oldVersion);
    
    for(let i=idx+1;i<versions.length;i++){
        let version=versions[i];
        if(version&&typeof scriptMap[version]=="function"){
            console.log(`执行${version}版本脚本`);
            scriptMap[version](oldVersion);
        }
    }
    console.log("更新完成，当前版本"+versions[versions.length-1]);
    
}


export default {
    versions:versions,
    checkVersion:checkVersion
};


// WEBPACK FOOTER //
// ./src/config/versions.js